/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import DisableAccessForm from './DisableAccessForm/DisableAccessForm';
import DisableAccessSuccess from './DisableAccessSuccess/DisableAccessSuccess';
import DisableAccessError from './DisableAccessError/DisableAccessError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccess extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;
    const formData: Object = this.props.formData;
    const fields: Array<Object> = [
      {
        name: 'disableUserAccessForm',
        label: t('general:actions.disable_access'),
        title: 'Disable Access',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_disabling_access'),
            rules: 'required|string',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.account_no_longer_in_use'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().disableUserAccessForm;

        actionDrawerStore.disableUserAccess(currentAccountDetails.id, {
          user_emails: formData.email,
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Disable Access',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { formData, currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.disable_access')} />
          <DisableAccessError user={formData} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.disable_access')} />
          <DisableAccessSuccess user={formData} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.disable_access')} />
        <DisableAccessForm
          user={formData}
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
